"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
var react_google_places_autocomplete_1 = __importDefault(require("react-google-places-autocomplete"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var lodash_1 = require("lodash");
var UserContext_1 = __importDefault(require("../../context/UserContext"));
var VacancyAlertForm = function (_a) {
    var _b;
    var onSubmit = _a.onSubmit, _c = _a.isEdit, isEdit = _c === void 0 ? false : _c, _d = _a.initialInput, initialInput = _d === void 0 ? {
        email: (_b = localStorage.getItem('email')) !== null && _b !== void 0 ? _b : '',
        search_terms: '',
        location: '',
        distance: 5,
    } : _d;
    var userId = (0, react_1.useContext)(UserContext_1.default).userId;
    var _e = (0, react_1.useState)(initialInput), input = _e[0], setInput = _e[1];
    var updateInput = function (value, inputName) {
        if (inputName === 'email') {
            localStorage.setItem('email', value);
        }
        setInput(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[inputName] = value, _a)));
        });
    };
    var distance = {
        onChange: function (e) {
            updateInput(e.target.value, 'distance');
        },
        options: [
            { value: 5, display: '5km' },
            { value: 10, display: '10km' },
            { value: 25, display: '25km' },
            { value: 50, display: '50km' },
            { value: 100, display: '100km' },
            { value: 'all', display: 'All' },
        ],
        initialValue: 25,
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogContent, __assign({ sx: {
                    p: '1.25rem !important',
                    height: '400px',
                    overflow: 'visible',
                } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                        display: 'grid',
                        gridTemplateColumns: { lg: 'repeat(2, 1fr)' },
                        gap: 3,
                    } }, { children: [!userId && !isEdit && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                gridColumn: 'span 2 / span 2',
                            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { children: trans_1.default.get('columns.vacancy_alert.email') }), (0, jsx_runtime_1.jsx)(material_1.TextField, { sx: {
                                        width: '100%',
                                    }, id: "email", variant: "outlined", placeholder: trans_1.default.get('columns.vacancy_alert.email_placeholder'), value: input.email, onChange: function (e) { return updateInput(e.target.value, 'email'); } })] }))), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                gridColumn: 'span 2 / span 2',
                            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { children: trans_1.default.get('columns.vacancy_alert.search_term') }), (0, jsx_runtime_1.jsx)(material_1.TextField, { sx: {
                                        width: '100%',
                                    }, id: "search_terms", variant: "outlined", placeholder: trans_1.default.get('columns.vacancy_alert.search_term_placeholder'), value: input.search_terms, onChange: function (e) { return updateInput(e.target.value, 'search_terms'); } })] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                display: 'flex',
                                flexDirection: 'column',
                            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { children: trans_1.default.get('columns.vacancy_alert.where') }), (0, jsx_runtime_1.jsx)(react_google_places_autocomplete_1.default, { apiKey: process.env.GOOGLE_JS_KEY, selectProps: {
                                        styles: {
                                            container: function (provided) { return (__assign(__assign({}, provided), { height: '100%' })); },
                                            control: function (provided, _a) {
                                                var isFocused = _a.isFocused;
                                                return (__assign(__assign({}, provided), { '&:hover': {
                                                        borderColor: '#ff4f6b',
                                                        boxShadow: '0 0 0 1px #ff4f6b',
                                                    }, borderColor: isFocused ? '#ff4f6b' : provided.borderColor, boxShadow: isFocused ? '0 0 0 1px #ff4f6b' : provided.borderColor, height: '100%' }));
                                            },
                                        },
                                        value: input.location || '',
                                        onChange: function (value) { return updateInput(value, 'location'); },
                                        placeholder: trans_1.default.get('columns.vacancy_alert.where_placeholder'),
                                        componentRestrictions: {
                                            country: ['nl', 'be'],
                                        },
                                    }, apiOptions: {
                                        language: 'nl',
                                        region: 'nl',
                                    } })] })), (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { children: trans_1.default.get('labels.frontend.vacancy.distance') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ onChange: function (e) { return updateInput(e.target.value, 'distance'); }, fullWidth: true, value: input.distance }, { children: (0, lodash_1.map)(distance.options, function (option) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: option.value }, { children: option.display || option.value }), option.value)); }) }))] })] })) })), (0, jsx_runtime_1.jsx)(material_1.DialogActions, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ className: "btn btn-primary", onClick: function () { return onSubmit(input); } }, { children: isEdit ? trans_1.default.get('buttons.general.crud.edit') : trans_1.default.get('buttons.general.crud.create') })) })] }));
};
exports.default = VacancyAlertForm;
